module.exports = __webpack_public_path__ + "img/HandsOnlyCPRTrainingPart2.3db4fd09.jpg";